<div class="modal-header">
  <h6 class="modal-title">
    @if (isEdit()) {
      <ng-container i18n="@@pdc.dashboard_admin.template.edit_title">Edit template</ng-container>
    } @else {
      <ng-container i18n="@@pdc.dashboard_admin.template.new_title">New template</ng-container>
    }
  </h6>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">&times;</button>
</div>

<div class="modal-body tem-body">
  <div class="tem-field">
    <label for="tem-key" i18n="@@pdc.dashboard_admin.field.key">Key (slug)</label>
    <input id="tem-key" type="text" class="form-control form-control-sm" [ngModel]="key()" (ngModelChange)="key.set($event)" [readonly]="isEdit()" />
  </div>

  <div class="tem-field">
    <label for="tem-name" i18n="@@pdc.dashboard_admin.field.name">Name</label>
    <input id="tem-name" type="text" class="form-control form-control-sm" [ngModel]="name()" (ngModelChange)="name.set($event)" />
  </div>

  <div class="tem-field">
    <label for="tem-visibility" i18n="@@pdc.dashboard_admin.field.visibility">Visibility</label>
    <select id="tem-visibility" class="form-select form-select-sm" [ngModel]="visibility()" (ngModelChange)="visibility.set($event)">
      <option value="public" i18n="@@pdc.dashboard_admin.visibility.public">public</option>
      <option value="tenant" i18n="@@pdc.dashboard_admin.visibility.tenant">tenant</option>
      <option value="sub_tenants" i18n="@@pdc.dashboard_admin.visibility.sub_tenants">sub_tenants</option>
    </select>
  </div>

  <div class="row g-3">
    <div class="tem-field col-6">
      <label for="tem-position" i18n="@@pdc.dashboard_admin.field.position">Position</label>
      <input id="tem-position" type="number" min="0" class="form-control form-control-sm" [ngModel]="position()" (ngModelChange)="position.set($event)" />
    </div>
    <div class="tem-field col-6 tem-field--check">
      <div class="form-check form-switch tem-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="tem-enabled" [ngModel]="enabled()" (ngModelChange)="enabled.set($event)" />
        <label class="form-check-label" for="tem-enabled" i18n="@@pdc.dashboard_admin.field.enabled">Enabled</label>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="button-secondary-outlined" (click)="close()"><span i18n="@@pdc.dashboard_admin.action.cancel">Cancel</span></button>
  <button type="button" class="button-secondary" (click)="save()"><span i18n="@@pdc.dashboard_admin.action.save_template">Save template</span></button>
</div>
